exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".forgotPassword-module-pwdforgot_container{height:100vh;background:var(--background-desktop)}@media screen and (max-width: 1120px){.forgotPassword-module-pwdforgot_container{background:var(--background-mobile)}}.forgotPassword-module-pwdforgot_container .forgotPassword-module-page_wrapper{padding-top:96px}", ""]);

// Exports
exports.locals = {
	"pwdforgot_container": "forgotPassword-module-pwdforgot_container",
	"page_wrapper": "forgotPassword-module-page_wrapper"
};